<template>
  <div
    class="alert text-white font-weight-bold d-flex align-items-center"
    role="alert"
    :class="getClasses(color, dismissible, textSize)"
  >
    <div class="alert-icon me-2">
      <i :class="getIcon(icon)" />
    </div>
    <div class="alert-text w-100">
      <slot />
    </div>
    <button
      v-if="dismissible"
      type="button"
      class="btn-close d-flex justify-content-center align-items-center"
      data-bs-dismiss="alert"
      aria-label="Close"
    >
      <span aria-hidden="true" class="text-lg font-weight-bold">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "argon-alert",
  props: {
    color: {
      type: String,
      default: "success",
    },
    icon: String,
    dismissible: {
      type: Boolean,
      default: false,
    },
    textSize: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClasses: (color, dismissible, textSize) => {
      let colorValue, dismissibleValue, fontSize;

      colorValue = color ? `alert-${color}` : null;

      dismissibleValue = dismissible ? "alert-dismissible fade show" : null;

      fontSize = textSize ? `text-${textSize}` : null;

      return `${colorValue} ${dismissibleValue} ${fontSize}`;
    },
    getIcon: (icon) => (icon ? icon : null),
  },
};
</script>
